export class PipeRingModel {
    _id: string;
    articleId: number;
    name: string;
    piperingGroupId: number;
    corrosionProtectionId: number;
    picture: string;
    stepFile: string;
    piperingFamilyId: number;
    _piperingFamilyId: string;

    constructor(id = '',
        articleId = null,
        name = '',
        piperingGroupId = null,
        corrosionProtectionId = null,
        picture = '',
        stepFile = '',
        piperingFamilyId = null,
        _piperingFamilyId = '') {
            this._id = id;
            this.articleId = articleId;
            this.name = name;
            this.piperingGroupId = piperingGroupId;
            this.corrosionProtectionId = corrosionProtectionId;
            this.stepFile = stepFile;
            this.picture = picture;
            this.piperingFamilyId = piperingFamilyId;
            this._piperingFamilyId = _piperingFamilyId;
    }
}
